import { NicheJwtLogin } from "niche-ui-component";
import {
  userGenerateJwtTokenUrl,
  userJwtLoginSchemaUrl,
  userJwtLoginUrl,
} from "../Common/endpoints";
import { Col, Row } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLoggedIn } from "../../reducers/authSlice";
import "./style.css";
import { setOrgDetails, setUserDetails } from "../Common/Utils";
import { useEffect } from "react";
import { useOrganization } from "../../OrganizationProvider";
import { MobileOutlined } from "@ant-design/icons";
import { getApis } from "../Common/apis";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const organization = useOrganization();

  useEffect(() => {
    document.title = organization?.name;
  }, [organization]);

  const generateOrgToken = async (data) => {
    if (data?.organisations?.[1]?.id) {
      await getApis(
        userGenerateJwtTokenUrl,
        { orgId: data?.organisations?.[1].id },
        data?.authToken
      )
        .then((response) => {
          setOrgDetails(response?.data, data?.organisations?.[1]?.id);
        })
        .catch((e) => console.log(e.response?.data?.message));
      dispatch(setLoggedIn());
    } else {
      // NO other orgs
      console.log("No Access to any Organization");
      dispatch(setLoggedIn());
    }
  };

  const handleSubmit = (response) => {
    setUserDetails(response?.data);
    if (response?.data?.organisations?.[0]?.type === "ADMINISTRATOR") {
      generateOrgToken(response?.data);
    } else {
      dispatch(setLoggedIn());
      navigate("/");
    }
  };

  return (
    <Row justify="center" className="mt1">
      <Col xs={24} sm={24} md={20} lg={20} xl={20}>
        <Row>
          <Col span={24}>
            <img
              src={`${organization.s3BucketBaseUrl}/OuterLogo.svg`}
              alt="Logo"
            />
          </Col>
        </Row>

        <Row className="mt2">
          <Col className="h1-header">Login with Email</Col>
        </Row>

        <Row className="mt3 mb2">
          <Col span={24}>
            <NicheJwtLogin
              handleSubmit={handleSubmit}
              url={userJwtLoginUrl}
              schemaUrl={userJwtLoginSchemaUrl}
              linkText="Forgot Password?"
              linkUrl="/forgotPassword"
            />
          </Col>
        </Row>
        <Row className="mt2 mb1 flex-center">
          <Col>
            <Link to="/sendOtp" title="Login via Mobile">
              <MobileOutlined className="mr025" />
              Login
            </Link>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Login;
